module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.loadingContent) ? _c('div', [_c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.froalaConfig
    },
    model: {
      value: (_vm.mensagem),
      callback: function($$v) {
        _vm.mensagem = $$v
      },
      expression: "mensagem"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2e4ff5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/ckeditor.vue
// module id = 1401
// module chunks = 45